import { z } from 'zod';
/** Дата без времени: `2026-09-15`. */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Ожидается дата в формате ГГГГ-ММ-ДД')
    .refine((v) => !Number.isNaN(Date.parse(`${v}T00:00:00Z`)), 'Такой даты не существует');
/** Время суток: `09:15`. */
export const timeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Ожидается время в формате ЧЧ:ММ');
// Нормализация идёт до проверки формата, иначе адрес с пробелом по краям
// не пройдёт валидацию, хотя после trim он корректен.
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email('Проверьте адрес почты').max(254));
export const passwordSchema = z
    .string()
    .min(8, 'Пароль не короче 8 символов')
    .max(128, 'Пароль не длиннее 128 символов');
export const personNameSchema = z
    .string()
    .trim()
    .min(1, 'Заполните поле')
    .max(80, 'Слишком длинное значение');
export const uuidSchema = z.uuid('Некорректный идентификатор');
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    q: z.string().trim().max(200).optional(),
    sort: z.string().max(64).optional(),
});
export const dateRangeSchema = z
    .object({
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
})
    .refine((v) => !v.from || !v.to || v.from <= v.to, {
    message: 'Начало периода позже его конца',
    path: ['from'],
});
/** Коды ошибок, на которые интерфейс реагирует особым образом. */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'INVITE_EXPIRED',
    'INVITE_REVOKED',
    'INVITE_LIMIT_REACHED',
    'EMAIL_TAKEN',
    'BLOCK_LOCKED',
    'TEST_ALREADY_PASSED',
    'NOT_A_WEEKDAY',
    'DATE_IN_PAST',
    'ACCOUNT_BLOCKED',
    'RATE_LIMITED',
    'INTERNAL',
];
/** Выходной день по календарю. Праздники не учитываются — см. docs/06. */
export function isWeekend(isoDate) {
    const day = new Date(`${isoDate}T00:00:00Z`).getUTCDay();
    return day === 0 || day === 6;
}
//# sourceMappingURL=common.js.map